// removed by extract-text-webpack-plugin
module.exports = {"loginPage":"_2jszaHgVPDIaXwlckOiTe0","loginBox":"_1FRFhi8f9GB94X1sp_FZw1","boxHeader":"_1050gZn8RTutKMwMTYWN4P","buttonsBox":"_3c3_dEshGIJuWrZWeCK4c5","logoImage":"_2qA1fFj1u5tWfZAS5aBc9g"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/accountPages/LoginPage.scss
// module id = 581
// module chunks = 0